import { INIT } from './view'

export const NAMESPACE = 'KanBo/Board/incomingMails/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'

const defaultBoardState = {
  isLoading: false,
  isLoaded: false
}

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case SET_LOAD_STATUS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded
        }
      } : state
    default: return state
  }
}

export function setLoadStatus ({ boardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      boardId,
      isLoading,
      isLoaded
    }
  }
}
